import BannerCta from '@/components/general/BannerCta';
import PageCardHeader from '@/components/general/PageCard/PageCardHeader';
import { avatarBg } from '@/functions/formats';
import MainIcons from '@/icons/main';
import React, { useState } from 'react';
import styles from '../BlogsAside/styles.module.css';
import AppInput from '@/components/common/AppInput';
import Button from '@/components/common/Button';

export default function BlogsBanner() {
  const [email, setEmail] = useState('');
  return (
    <BannerCta className={`${styles.bannercta}`}>
      <PageCardHeader
        icon={<MainIcons.BellIcon fill="var(--paper)" />}
        backgroundIcon={avatarBg(0)}
      />
      <div className={`${styles.bannerContent}`}>
        <p className={`${styles.bannerTitle}`}>خبرنامهٔ کارا</p>
        <p className={`${styles.bannerText}`}>
          بهترین مقالات و راهنماها را هر هفته در ایمیلت دریافت کن.
        </p>
        <AppInput
          placeholder="ایمیل شما"
          wrapper="darkInput"
          value={email}
          onChange={(e: { target: { value: string } }) => setEmail(e?.target?.value)}
        />
        <Button className={`btn btn-primary squareButton w-full`}>
          <MainIcons.send fill="var(--paper)" />
          عضویت رایگان
        </Button>
      </div>
    </BannerCta>
  );
}
